import React from 'react';
import styled from 'styled-components';
import Form from 'components/ui/Form';
import { getTranslatedString } from 'helpers/i18n';
import TextBox from 'components/ui/TextBox';
import ReactPhoneInput from 'components/shared/ReactPhoneInput';

const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const StyledInnerContainer = styled.div`
  width: 70%;
`;

const StyledLabel = styled.label`
  margin: 20px 0px 5px;
`;

export const EmailPhoneNumberConfirmationForm = ({ values, setFieldValue, handleChange, errors, touched }) => {
  return (
    <StyledContainer>
      <StyledInnerContainer>
        <StyledLabel>{getTranslatedString('email')}</StyledLabel>
        <Form.Item
          validateStatus={errors.email && touched.email && 'error'}
          help={errors.email}
        >
          <TextBox
            name="email"
            value={values.email}
            fullWidth
            onChange={handleChange}
            style={{ fontSize: '15px' }}
            variant="outlined"
            size="large"
          />
        </Form.Item>
        <StyledLabel>{getTranslatedString('phoneNumber')}</StyledLabel>
          <Form.Item
            validateStatus={errors.phone_number  && touched.phone_number && 'error'}
            help={errors.phone_number}
          >
            <ReactPhoneInput
              value={values.phone_number}
              onChange={value => setFieldValue('phone_number', value)}
              hasError={errors.phone_number}
            />
          </Form.Item>
      </StyledInnerContainer>
    </StyledContainer>
  );
};
